import React, { useState } from "react";
import styled from "styled-components";
import { CaretDown } from "phosphor-react";
import { ClickAwayListener } from "@mui/material";
import colors from "../../utils/constants/COLORS";
import { ErrorContainer } from "../Styled/ErrorContainer.style";
import { ErrorStyle } from "../Styled/Error.style";
import useType from "../../utils/hooks/useType";
import ErrorLabelStyle from "../Styled/ErrorLabel.style";

export default function Select({
  handleChange,
  options,
  defaultValue,
  value,
  prefix,
  label,
  id,
  title,
  width,
  validate,
  disabled = false,
}) {
  const [showOptions, setShowOptions] = useState(false);
  const [error, setError] = useType("string", "");

  return (
    <ClickAwayListener
      onClickAway={() => {
        if (showOptions) {
          validate && setError(validate());
        }
        setShowOptions(false);
      }}
    >
      <ErrorContainer>
        <ErrorStyle error={error} width={width}>
          <SelectStyle
            onClick={() => !disabled && setShowOptions((prev) => !prev)}
            width={width}
          >
            {label && (
              <LabelStyle value={value} htmlFor={id} title={title}>
                {label}
              </LabelStyle>
            )}
            {prefix}{" "}
            <Placeholder>{value || defaultValue || "Select"}</Placeholder>{" "}
            <CaretDown weight="thin" size={14} />
            {showOptions && (
              <OptionsStyle>
                <OptionStyle onClick={() => setShowOptions((prev) => !prev)}>
                  {defaultValue}
                </OptionStyle>
                {options?.map((option, index) => (
                  <OptionStyle
                    key={index}
                    onClick={() => {
                      handleChange(option?.option || option);
                      setError(validate(option?.option || option));
                    }}
                    selected={(option?.option || option) === value}
                    name={option?.option || option}
                    title={option?.info}
                  >
                    {option?.option || option}
                  </OptionStyle>
                ))}
              </OptionsStyle>
            )}
          </SelectStyle>
        </ErrorStyle>
        <ErrorLabelStyle error={error} width={width}>
          {error}
        </ErrorLabelStyle>
      </ErrorContainer>
    </ClickAwayListener>
  );
}

const SelectStyle = styled.div`
  position: relative;
  cursor: pointer;
  border: 1px solid lightgray;
  padding: 5px 15px;
  border-radius: 4px;
  max-width: 220px;
  height: 33.2px;
  width: ${(props) => props.width || "100%"};
  font-size: smaller;
  color: gray;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const OptionsStyle = styled.div`
  display: grid;
  gap: 5px;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  box-shadow: 1px 6px 12px grey;
  padding: 5px 0;
  border: 1px solid lightgray;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  width: 100%;
  max-height: 250px;
  overflow: auto;
  z-index: 100;
`;

const OptionStyle = styled.span`
  padding: 0 5px;
  background-color: ${(props) => (props.selected ? "#008060" : "#fff")};
  color: ${(props) => (props.selected ? "#fff" : "#008060")};
  border-bottom: ${(props) =>
    props.selected ? "1px solid #fff" : "1px solid lightgrey"};
  text-transform: capitalize;

  &&:hover {
    background-color: ${(props) => (props.selected ? "#016b50" : "aliceblue")};
  }
  &&:first-child {
    color: ${colors.default.color};
    font-style: italic;

    &&:hover {
      background-color: unset;
    }
  }

  &[name="Silver"] {
    color: silver !important;
  }
  &[name="White"] {
    color: grey !important;
  }
  &[name="Red"] {
    color: red !important;
  }
  &[name="Blue"] {
    color: blue !important;
  }
  &[name="Grey"] {
    color: grey !important;
  }
  &[name="Black"] {
    color: black !important;
  }
  &[name="Orange"] {
    color: orange !important;
  }
  &[name="TBA"] {
    color: grey !important;
  }
`;

const LabelStyle = styled.label`
  position: absolute;
  transition: 100ms ease-in-out;
  color: gray;
  cursor: text;
  user-select: none;
  white-space: nowrap;
  display: flex;
  align-items: center;

  font-size: x-small;
  top: -10px;
  background-color: #fff;
  padding: 2px 5px;
  left: 10px;
`;

const Placeholder = styled.span`
  text-transform: capitalize;
  color: ${colors.default.color};
  white-space: nowrap;
  overflow-x: hidden;
`;
